import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { finalize, startWith, Subject, tap } from 'rxjs';
import { SharedService } from '../shared.service';

@Component({
    selector: 'ashcorp-error',
    templateUrl: './error.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AshcorpErrorComponent implements OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    reported: boolean = false;

    @Output() goBackEvent: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private _sharedService: SharedService,
        private _cdr: ChangeDetectorRef
    ) {
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    refresh(): void {
        location.reload();
    }

    report(): void {
        this._sharedService
            .send_error()
            .pipe(
                startWith(() => { }),
                tap(() => {
                    this._sharedService.show_loader();
                }),
                finalize(() => {
                    this.reported = true;
                    this._sharedService.hide_loader();
                    this._cdr.detectChanges();
                })
            )
            .subscribe();
    }

    goBack(): void {
        this.goBackEvent.emit();
    }
}
